export function isErrorType(aggStatusString: string) {
  const acceptable = ['NEW', 'OK', 'MFA_CHALLENGE_READY_FOR_USER', 'DISCOVERED_ACCOUNTS_READY_FOR_USER', 'NO_ACCOUNTS_REFRESHED'];
  return !acceptable.includes(aggStatusString);
}
